export default "__VITE_ASSET__f37ce52b__"